/**
 * @desc 获取用户菜单列表
 */
const URL = "/rantion-ucenter";
import http, { updateResponse } from "@/http";
export function request(userNo: string | number, options?: any) {
  return updateResponse(
    http(URL + `/sysMenu/source/${userNo}`, {
      method: "GET",

      ...options,
    }),
  );
}
